import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ed97a94"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex over sidebar-wrapper",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = {
  key: 0,
  class: "sidebar-container"
}
const _hoisted_3 = { class: "sidebar-inner-fixed" }
const _hoisted_4 = { class: "sidebar-constant-width-container" }
const _hoisted_5 = {
  key: 1,
  class: "spacer flex-shrink-0"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "content-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showSidebar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["sidebar", { 'sidebar-collapse-toggled': _ctx.sidebarCollapseToggled }])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "sidebar", { class: "sidebar-contents" }, undefined, true)
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSidebar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-info toggle-collapse-btn", { toggled: _ctx.sidebarCollapseToggled }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sidebarCollapseToggle && _ctx.sidebarCollapseToggle(...args)))
          }, _hoisted_7, 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}